import { useEffect } from "react";

interface LightboxProps {
  images: string[];
  index: number | null;
  onClose: () => void;
  onChange: (index: number) => void;
  alt?: string;
}

export default function Lightbox({ images, index, onClose, onChange, alt = "剧照预览" }: LightboxProps) {
  useEffect(() => {
    if (index === null) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft") onChange((index - 1 + images.length) % images.length);
      if (event.key === "ArrowRight") onChange((index + 1) % images.length);
    };
    window.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [index, images.length, onChange, onClose]);

  if (index === null) return null;

  return (
    <div className="fixed inset-0 z-[90] flex flex-col items-center justify-center bg-foreground-950/92 px-4 py-6">
      <button
        type="button"
        onClick={onClose}
        aria-label="关闭预览"
        className="absolute right-4 top-4 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-background-50/50"
      >
        <i className="ri-close-line text-xl" />
      </button>

      <div className="relative flex w-full max-w-5xl items-center justify-center">
        <button
          type="button"
          onClick={() => onChange((index - 1 + images.length) % images.length)}
          aria-label="上一张"
          className="absolute left-1 z-10 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-50/15 text-background-50 transition-colors hover:bg-background-50/25 md:-left-4"
        >
          <i className="ri-arrow-left-s-line text-2xl" />
        </button>
        <img
          src={images[index]}
          alt={`${alt} ${index + 1}`}
          title={`${alt} ${index + 1}`}
          className="max-h-[76vh] w-auto max-w-full rounded-md object-contain"
        />
        <button
          type="button"
          onClick={() => onChange((index + 1) % images.length)}
          aria-label="下一张"
          className="absolute right-1 z-10 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-50/15 text-background-50 transition-colors hover:bg-background-50/25 md:-right-4"
        >
          <i className="ri-arrow-right-s-line text-2xl" />
        </button>
      </div>

      <p className="mt-4 font-label text-xs tracking-widest text-background-100/70">
        {index + 1} / {images.length}
      </p>
    </div>
  );
}